import type { ReactNode } from "react";
import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { ACTION_WORDING } from "@shared-core/domain/supplier-portal-wording";
import { Button } from "../../app/components/primitives/button";
import { SupplierHeader } from "./SupplierHeader";

/**
 * Chrome for a purchase order opened by its emailed link: no account needed, so no nav, only the brand and a way
 * to sign in for someone who has a login. `returnTo` is where signing in comes back to (the order, without the
 * link's token).
 */
export function LinkShell({
  returnTo,
  children,
}: {
  returnTo: string | null;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-muted/30">
      <SupplierHeader
        right={
          <Button asChild variant="outline" size="sm">
            <Link to={paths.supplierSignIn({ returnTo })}>
              {ACTION_WORDING.signIn}
            </Link>
          </Button>
        }
      />
      <main className="mx-auto grid max-w-5xl gap-4 px-4 py-5 sm:px-6">
        {children}
      </main>
    </div>
  );
}
